import { useContext, useEffect, useRef, useState } from "react";
import { GlobalContext } from "../../context/globalContext";
import { BusinessContext } from "../../context/businessContext";
import { useNavigate } from "react-router-dom";
import { Box } from "@mui/material";
import TkStepper from "../../components/atoms/TkStepper";
import { fakeTableList, schema, schemaDAIKOSHA, stepperData } from "./parts";
import TkFakeTable from "../../components/molecules/TkFakeTable";
import TkBackButton from "../../components/molecules/TkBackButton";
import authorityUserType from "../../assets/data/TkAuthorityProperty";
import TkMessageDialog from "../../components/molecules/TkMessageDialog";
import { httpIAPI_RET003 } from "./api/request";
import { Prefectures } from "../../assets/data/Constants";
import { TkGetCode } from "../../utils/TkGetCode";
import _ from "lodash";

/**
 * SCRR411114合算制度利用申出の手続き（連絡先の登録）
 * 合算制度利用申出の手続きに連絡先を登録する。
 * @return SCRR411114
 */
const SCRR411114 = () => {
  const navigate = useNavigate();

  const { state, setState } = useContext(GlobalContext);
  const { state: businessState, setState: setBusinessState } =
    useContext(BusinessContext);
  const userType = state.authInfo?.userType;
  const context = businessState.job_36;
  const isUserTypeKiko =
    state.authInfo?.userType === authorityUserType.userTypeNumber.KIKO;
  const isTaisyokusya =
    state.authInfo?.userType === authorityUserType.userTypeNumber.TAISYOKUSYA;
  const isHoujin =
    state.authInfo?.userType === authorityUserType.userTypeNumber.KEIYAKUSYA;

  const [stateFakeTableList, setStateFakeTableList] = useState<any>([]);
  const [schemaData, setSchemaData] = useState(schema);
  const [phoneNum, setPhoneNum] = useState("");
  const [open, setOpen] = useState(false);
  const stateFakeTableListCp = useRef(_.cloneDeep(fakeTableList));

  useEffect(() => {
    // 持回り情報を初期表示する
    let resArr = stateFakeTableListCp.current;

    // 退職者名
    let retireeName = resArr.find((item) => item.keyword === "retireeName")!;
    retireeName.showLine = isUserTypeKiko;
    retireeName.contractorNumber = context?.staffName;

    //退職理由の表示
    resArr.find(
      (item) => item.keyword === "retireProcedureReason"
    )!.setDefaultValue = context?.retireProcedureReason;
    //郵便番号の表示
    resArr.find((item) => item.keyword === "zipcode")!.setDefaultValue =
      context?.zipcode;

    resArr.find((item) => item.keyword === "locationGroup")!.valueObject = {
      prefectures: TkGetCode(Prefectures, context?.prefectureCd) || "",
      city: context?.addressCity || "",
      address: context?.addressOthers || "",
    };
    //電話番号の表示
    resArr.find((item) => item.keyword === "tel")!.setDefaultValue =
      context?.tel;
    //退職者メールアドレスの表示
    const _email = isTaisyokusya ? context?.email ?? state?.authInfo?.email : context?.email;
    resArr.find((item) => item.keyword === "email")!.setDefaultValue = _email;
    resArr.find((item) => item.keyword === "emailConfirm")!.setDefaultValue = _email;
    //代行者メールアドレスの表示
    const _agentEmail = isHoujin ? context?.agentEmail ?? state?.authInfo?.email : context?.agentEmail;
    resArr.find((item) => item.keyword === "agentEmail")!.setDefaultValue = _agentEmail;
    resArr.find((item) => item.keyword === "agentEmailConfirm")!.setDefaultValue = _agentEmail;

    //ユーザータイプが契約者の場合
    if (userType === authorityUserType.userTypeNumber.KEIYAKUSYA) {
      let agentEmail = resArr.find((item) => item.keyword === "agentEmail")!;
      agentEmail.showLine = true;
      let agentEmailConfirm = resArr.find(
        (item) => item.keyword === "agentEmailConfirm"
      )!;
      agentEmailConfirm.showLine = true;
      let email = resArr.find((item) => item.keyword === "email")!;
      email.requiredIcon = false;
      let emailConfirm = resArr.find(
        (item) => item.keyword === "emailConfirm"
      )!;
      emailConfirm.requiredIcon = false;
      setSchemaData(schemaDAIKOSHA);
    }

    setStateFakeTableList([...resArr]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    let resArr = stateFakeTableListCp.current;
    let zipcode = resArr.find((item) => item.keyword === "zipcode")!;
    let tel = resArr.find((item) => item.keyword === "tel")!;

    // 住所検索
    zipcode.getPostalCodeValue = (value: any) => {
      const data = value.value;

      resArr.find((item) => item.keyword === "locationGroup")!.valueObject = {
        prefectures: data.address1,
        city: `${data.address2}${data.address3}`,
        address: "",
      };

      setState({
        ...state,
        errorMsgId: "",
      });
    };

    zipcode.getPostalCodeError = (value: any) => {
      setState({
        ...state,
        errorMsgId: value,
      });
    };

    tel.onGetInputValue = (value: any) => {
      setPhoneNum(value.target.valueForShow);
    };

    setStateFakeTableList([...resArr]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state]);

  const handleSubmit = async (data: any, index: any) => {
    //業務チェック;
    switch (index) {
      case 0: // 一時保存
        // 合算制度利用申出（1回目）更新実行
        try {
          const res = await httpIAPI_RET003({
            applyId: context?.applyId,
            tempSaveStep: 2,
            staffNo: context?.staffNo,
            contractorNo: isUserTypeKiko
              ? businessState.common?.contractorNo
              : state.authInfo?.contractorNo,
            facilityNo: context?.facilityNo,
            retireDate: context?.retireDate,
            retireProcedureReason: data.retireProcedureReason,
            zipcode: data.zipcode,
            prefectureCd:
              Prefectures[
                data.locationGroup?.prefectures as keyof typeof Prefectures
              ],
            addressCity: data.locationGroup?.city,
            addressOthers: data.locationGroup?.address,
            tel: phoneNum,
            email: data.email,
            agentEmail: data.agentEmail,
            updateDateTime: context?.updateDatetime,
            screenId: "SCRR411114",
            fileList: businessState.job_36?.fileList?.map((item) => ({
              serialNo: item.serialNo,
              facilityNo: item.facilityNo,
              staffNo: item.fileList_staffNo,
              formKbn: item.formKbn,
              formClass: item.formClass,
              fileName: item.formName,
              fileBase64: item.file,
            })),
          });

          if (res.resultCd === "I0000") {
            setState({
              ...state,
              errorMsgId: "",
            });

            setBusinessState({
              ...businessState,
              job_36: {
                ...businessState.job_36,
                applyId: res.applyId,
                tempSaveStep: 2,
              },
            });

            setOpen(true);
          } else {
            setState({
              ...state,
              errorMsgId: res.resultCd,
            });
          }
        } catch (error) {
          navigate("/error");
        }
        break;

      case 1: // 次へ
        // 持回り情報
        setBusinessState({
          ...businessState,
          job_36: {
            ...businessState.job_36,
            retireProcedureReason: data.retireProcedureReason,
            zipcode: data.zipcode,
            prefectureCd:
              Prefectures[
                data.locationGroup?.prefectures as keyof typeof Prefectures
              ],
            addressCity: data.locationGroup?.city,
            addressOthers: data.locationGroup?.address,
            tel: phoneNum,
            email: data.email,
            agentEmail: data.agentEmail,
          },
        });
        navigate("/SCRR410017");
        break;
    }
  };

  return (
    <Box data-testid="SCRR411114PageForTest">
      <TkStepper
        steps={stepperData}
        activeStep={1}
        savaStep={businessState.job_36?.tempSaveStep}
      />
      <TkFakeTable
        list={stateFakeTableList}
        submitButtonGroup={[
          { submitButtonText: "一時保存" },
          { submitButtonText: "次へ" },
        ]}
        buttonGroup={<TkBackButton />}
        ruleSchema={schemaData}
        onCheckAndSubmit={(e, index) => handleSubmit(e, index)}
      />
      <TkMessageDialog
        open={open}
        title="一時保存完了"
        contextText="　一時保存が完了しました。"
        onOky={() => setOpen(false)}
        okText="はい"
        cancelText=""
      />
    </Box>
  );
};

export default SCRR411114;
